import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ScrollService } from '../services/scroll.service';


@Injectable({
  providedIn: 'root'
})
export class ScrollGuard {

  constructor(private router: Router, private scrollService: ScrollService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    this.scrollService.scrollToTop();
    return true;
  }
}
